import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import styles from "./styles/pagination.module.scss";
import { googlePagination, pagination } from "./services";
import { NextButton, PrevButton } from "./components";
export default function Pagination(_ref) {
  var pageCount = _ref.pageCount,
      _ref$initialPage = _ref.initialPage,
      initialPage = _ref$initialPage === void 0 ? 1 : _ref$initialPage,
      previousLabel = _ref.previousLabel,
      nextLabel = _ref.nextLabel,
      onPageChange = _ref.onPageChange,
      activePage = _ref.activePage,
      googlePaginate = _ref.googlePaginate,
      forceSelect = _ref.forceSelect,
      forceDisplay = _ref.forceDisplay;

  var _useState = useState(initialPage - 1 || 0),
      selected = _useState[0],
      setSelected = _useState[1];

  useEffect(function () {
    onPageChange(selected);
  }, []);
  useEffect(function () {
    if (activePage) {
      setSelected(activePage);
    }
  }, [activePage]);
  useEffect(function () {
    setSelected(0);
  }, [forceSelect]);
  return /*#__PURE__*/_jsxs("ul", {
    className: [styles.pagination, !forceDisplay && pageCount && pageCount === 1 ? styles.hide : ''].join(' '),
    children: [previousLabel && /*#__PURE__*/_jsx(PrevButton, {
      selected: selected,
      setSelected: setSelected,
      onPageChange: onPageChange,
      previousLabel: previousLabel
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx("ul", {
        children: googlePaginate ? googlePagination(selected, pageCount, onPageChange, setSelected) : pagination(selected, pageCount, onPageChange, setSelected)
      })
    }), nextLabel && /*#__PURE__*/_jsx(NextButton, {
      selected: selected,
      setSelected: setSelected,
      onPageChange: onPageChange,
      nextLabel: nextLabel,
      pageCount: pageCount
    })]
  });
}